import { imageUrl } from '@helpers/image';
import { Device, until } from '@helpers/media';
import { responsiveSizes } from '@helpers/responsive';
import Breadcrumb from '@stories/Components/Breadcrumb/Breadcrumb';
import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
import FernBanner from '!file-loader!@img/banners-bg.jpg';
import FernBannerMobile from '!file-loader!@img/banners-bg-mobile.jpg';
import React from 'react';
import S from './InnerPageHero.styles';
const InnerPageHero = ({ breadcrumb, content, image, imageMode = 'crop', term, title, cta, }) => {
    const modeConvert = imageMode === 'cover' ? 'crop' : 'pad';
    return (React.createElement(S.Container, { flush: "both", "data-image": !!image, "data-image-mode": imageMode },
        React.createElement(S.Background, { alt: 'Plant image', draggable: false, loading: "lazy", role: "presentation", src: FernBanner, srcSet: [
                `${FernBannerMobile} 375w`,
                `${FernBannerMobile} 768w`,
                `${FernBanner} 1024w`,
                `${FernBanner} 1400w`,
            ].join(', ') }),
        React.createElement(S.Inner, null,
            breadcrumb?.length && (React.createElement(S.BreadcrumbWrapper, null,
                React.createElement(Breadcrumb, { items: breadcrumb }))),
            React.createElement(S.ContentWrapper, null,
                !term ? React.createElement(S.Title, null, title) : React.createElement(S.Title, null,
                    "You searched for \u2018",
                    term,
                    "\u2019"),
                content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content } }),
                cta?.text && (React.createElement(LinkButton, { themeOption: cta?.themeOption, title: cta?.text, href: cta?.url, target: cta?.target }))),
            image && (React.createElement(S.ImageWrapper, null,
                React.createElement(S.Image, { alt: image?.altText, draggable: false, loading: "eager", role: "presentation", src: imageUrl(image, {}), sizes: [`${until(Device.Tablet)} 100vw`, `50vw`].join(', '), srcSet: responsiveSizes([{ value: 100, breakpoint: Device.Tablet }, { value: 50 }], image, { heightratio: 387 / 665, mode: modeConvert }) })))),
        React.createElement(S.RssLogo, null)));
};
export default InnerPageHero;
